module.exports = __webpack_public_path__ + "static/media/RightCalendarArrow.6f49b1ca.svg";